import { render, staticRenderFns } from "./ManageAssetConfigModal.vue?vue&type=template&id=5f42f7b3&scoped=true&"
import script from "./ManageAssetConfigModal.vue?vue&type=script&lang=js&"
export * from "./ManageAssetConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f42f7b3",
  null
  
)

export default component.exports